import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { loadRuntimeConfig } from './config/runtimeConfig';

// Carregar configuração antes de renderizar o app
loadRuntimeConfig().then(() => {
  console.log('[App] Configuração carregada, iniciando aplicação...');
  
  const root = createRoot(document.getElementById('root')!);
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}).catch((error) => {
  console.error('[App] Erro ao carregar configuração:', error);
  // Renderizar mesmo assim, usando valores padrão
  const root = createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});